import { Button, Flex } from "theme-ui";
import { useEffect, useRef, useState } from "react";
import { Icon } from "../../../components/Icons/Icons";
import AccordionPane from "./AccordionPane";

export interface AccordionProps {
  id?: number;
  questionText: string;
  answerContent: string;
  url?: string;
  setPaneHeight?: (value: number) => void;
}

export const AccordionButton = (props: AccordionProps): JSX.Element => {
  const { questionText, id } = props;
  const paneRef = useRef(null);
  const [isActive, setActive] = useState(false);
  const [paneHeight, setPaneHeight] = useState(0);

  useEffect(() => {
    if (window.location.hash === `#question${id}`) {
      setActive(true);
    }
  }, []);

  function toggleAccordion() {
    setActive(!isActive);
  }

  return (
    <Flex
      sx={{
        flexDirection: "column",
        backgroundClip: "border-box",
        bg: "white",
        color: "text",
        maxWidth: "800px",
        width: "100%",
        borderRadius: "4px",
        border: "1px #707070 solid",
        // boxShadow: "0px 3px 20px #00000029",
        ":focus-within": {
          outline: "3px auto -webkit-focus-ring-color",
        },
        outline: isActive ? "-webkit-focus-ring-color auto 1px" : "",
      }}
    >
      <Button
        id={"question" + id}
        sx={{
          outline: "none",
          border: "none",
          display: "flex",
          cursor: "pointer",
          px: "0",
          pl: "20px",
          borderBottom: isActive ? "1px #707070 solid" : "none",
          minHeight: "80px",
          borderRadius: "0px",
          backgroundColor: isActive ? "brand.powderBlue" : "none",
          textAlign: "left",
          alignItems: "center",
          justifyContent: "space-between",
          background: isActive ? "brand.powderBlue" : "none",
          py: "10px",
          width: "100%",
          "&:hover": {
            transform: "none",
            outline: "none",
          },
          "&:focus": {
            outline: "none",
          },
          "&:focus-within": {
            outline: "none",
          },
        }}
        onClick={() => {
          toggleAccordion();
        }}
        role="button"
      >
        <h2
          sx={{
            variant: "text.h2HeaderSemiBold",
            color: "black",
            textAlign: "left",
            width: "80%",
          }}
          dangerouslySetInnerHTML={{ __html: questionText }}
        />
        <Flex
          sx={{
            bg: "brand.accentBlue",
            width: 24,
            height: 24,
            alignItems: "center",
            justifyContent: "center",
            borderRadius: 24,
            mr: 4,
          }}
        >
          {id !== 818 && (
            <Icon
              name="plus"
              id="plus"
              alt="plus sign"
              width="12"
              height="12"
              viewBox="0 0 15 15"
              sx={{
                verticalAlign: "center",
                transform: isActive ? "rotate(45deg)" : "rotate(0deg)",
                transition: "all .3s cubic-bezier(.87,.04,.23,.93)",
              }}
            />
          )}
        </Flex>
      </Button>
      <div
        ref={paneRef}
        sx={{
          height: id === 818 || isActive ? `${paneHeight}px` : "0px",
          overflow: "hidden",
          maxWidth: "95%",
          fontSize: 0,
          color: "text",
          transition: "height .3s  cubic-bezier(.87,.04,.23,.93)",
        }}
      >
        <AccordionPane {...props} setPaneHeight={setPaneHeight} />
      </div>
    </Flex>
  );
};

export default AccordionButton;
